<template>
  <transition name="fade" appear>
    <a
      :class="{ 'alternate-theme': alternateTheme }"
      v-if="external || link[0] === '#'"
      :href="link"
      > <span>{{ text }}</span></a
    >
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <span>{{ text }}</span>
    </button>
  </transition>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String,
    link: String,
    alternateTheme: Boolean,
    external: Boolean,
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  font-size: 0.825rem;
  font-family: 'Montserrat';
  font-weight: 700;
  text-decoration: none;
  background:none;
  color: var(--white);
  text-transform: uppercase;
  padding: 16px 16px;
  user-select: none;
  display: inline-block;
  position: relative;
  transition: 0.2s all ease-in-out;
  border-radius: 8px;
  background:var(--green);
  cursor: pointer;
  span {
    position: relative;
  }  
  &.alternate-theme {    
    background:var(--light-green);
    color: var(--green);    
    border:1px solid var(--green);      
  }
  &.selected {
    background: linear-gradient(96.44deg, #C88A65 19.42%, #F0B392 44.38%, #C88A65 69.75%);
    pointer-events: none;        
    color:var(--dark-grey);    
    &.alternate-theme {    
        background:var(--green);
    color: var(--white);    
    }
  }
  @media (hover: hover) {
    &:not(.disabled) {
      &:hover {
        background:var(--light-green);
            color: var(--ao-dark);
      }
    }
  }
}
</style>